import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  private currentQuestionSubject = new BehaviorSubject<number>(0);
  currentQuestions$ = this.currentQuestionSubject.asObservable();

  setCurrentQuestionNumber(questionNumber: number) {
    this.currentQuestionSubject.next(questionNumber);
  }
}
